export default __webpack_public_path__ + "static/media/individual-masthead-mob.ce812590.png";